import { GetListResponse } from "@app/types";
import { TransferHistory } from "@app/types/transfer-history.type";
import HttpService from "@core/services/http/http.service";
import { RequestParams, Signal } from "@core/services/http/http.type";

class _TransferHistoryService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<TransferHistory>>(
      "/admin/api/v2/transfer-histories",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public confirm(id: number) {
    return HttpService.post(`/admin/api/v2/transfer-histories/${id}`);
  }

  public reject(id: number, reason: string) {
    return HttpService.post(`/admin/api/v2/transfer-histories/${id}/reject`, {
      body: { reason },
    });
  }
}

const TransferHistoryService = new _TransferHistoryService();

export default TransferHistoryService;
